import BaseCommand from "@/models/api/commands/BaseCommand";

export class ContractorSetHiddenCommand extends BaseCommand {
  CommandName = "ContractorSetHidden";
  Command: unknown;
  constructor(sessionId: string, operationId: string, isHidden: boolean) {
    super(sessionId, operationId);
    this.Command = isHidden;
  }
}
